import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-900/80" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 flex" }
const _hoisted_3 = { class: "absolute left-full top-0 flex w-16 justify-center pt-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)
const _hoisted_5 = { class: "flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex h-16 shrink-0 items-center" }, " Ginolytics ", -1)
const _hoisted_7 = { class: "flex flex-1 flex-col" }
const _hoisted_8 = {
  role: "list",
  class: "flex flex-1 flex-col gap-y-7"
}
const _hoisted_9 = {
  role: "list",
  class: "-mx-2 space-y-1"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col" }
const _hoisted_12 = { class: "flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex h-40 mt-2 items-start" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "logo",
    class: "p-5",
    src: _imports_0
  })
], -1)
const _hoisted_14 = { class: "flex flex-1 flex-col" }
const _hoisted_15 = {
  role: "list",
  class: "flex flex-1 flex-col gap-y-7"
}
const _hoisted_16 = {
  role: "list",
  class: "-mx-2 space-y-1"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "sticky top-0 z-40 flex items-center gap-x-6 bg-white px-4 py-4 shadow-sm sm:px-6 lg:hidden" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 text-sm font-semibold leading-6 text-gray-900" }, "Ginolytics", -1)

import {Dialog, DialogPanel, TransitionChild, TransitionRoot} from "@headlessui/vue";
import {Bars3Icon, XMarkIcon} from "@heroicons/vue/24/outline";

import {Ref, ref} from 'vue'
import {
  DocumentDuplicateIcon,
  HomeIcon,
  UsersIcon,
  BanknotesIcon,
} from '@heroicons/vue/24/outline'

import { useRouter } from 'vue-router'
interface NavItem {
    name: string;
    href: string;
    icon: typeof HomeIcon | typeof UsersIcon | typeof DocumentDuplicateIcon | typeof BanknotesIcon
    current: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {


const router = useRouter()

const navigation:Ref<NavItem[]> = ref([
  { name: 'Dashboard', href: '/', icon: HomeIcon, current: true },
  { name: 'Milch', href: '/milk', icon: UsersIcon, current: false },
  { name: 'Gewicht', href: '/weight', icon: DocumentDuplicateIcon, current: false },
])
const sidebarOpen = ref(false)

function setCurrent(item:NavItem) {
    navigation.value.forEach((nav) => {
        nav.current = nav.name === item.name
    })
    router.push(item.href)
    sidebarOpen.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: sidebarOpen.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-50 lg:hidden",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (sidebarOpen.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "transition ease-in-out duration-300 transform",
                "enter-from": "-translate-x-full",
                "enter-to": "translate-x-0",
                leave: "transition ease-in-out duration-300 transform",
                "leave-from": "translate-x-0",
                "leave-to": "-translate-x-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "relative mr-16 flex w-full max-w-xs flex-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "ease-in-out duration-300",
                        "enter-from": "opacity-0",
                        "enter-to": "opacity-100",
                        leave: "ease-in-out duration-300",
                        "leave-from": "opacity-100",
                        "leave-to": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "-m-2.5 p-2.5",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = false))
                            }, [
                              _hoisted_4,
                              _createVNode(_unref(XMarkIcon), {
                                class: "h-6 w-6 text-white",
                                "aria-hidden": "true"
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("nav", _hoisted_7, [
                          _createElementVNode("ul", _hoisted_8, [
                            _createElementVNode("li", null, [
                              _createElementVNode("ul", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: item.name
                                  }, [
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (setCurrent(item)),
                                      class: _normalizeClass([item.current ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:text-indigo-600 hover:bg-gray-50', 'cursor-pointer group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'])
                                    }, [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                        class: _normalizeClass([item.current ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'h-6 w-6 shrink-0']),
                                        "aria-hidden": "true"
                                      }, null, 8, ["class"])),
                                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                                    ], 10, _hoisted_10)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("nav", _hoisted_14, [
          _createElementVNode("ul", _hoisted_15, [
            _createElementVNode("li", null, [
              _createElementVNode("ul", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.name
                  }, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (setCurrent(item)),
                      class: _normalizeClass([item.current ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:text-indigo-600 hover:bg-gray-50', 'cursor-pointer group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'])
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                        class: _normalizeClass([item.current ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'h-6 w-6 shrink-0']),
                        "aria-hidden": "true"
                      }, null, 8, ["class"])),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ], 10, _hoisted_17)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        type: "button",
        class: "-m-2.5 p-2.5 text-gray-700 lg:hidden",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (sidebarOpen.value = true))
      }, [
        _hoisted_19,
        _createVNode(_unref(Bars3Icon), {
          class: "h-6 w-6",
          "aria-hidden": "true"
        })
      ]),
      _hoisted_20
    ])
  ], 64))
}
}

})